import React from 'react';



const TeamCulture = () => {
  return null;
};

export default TeamCulture;